define('app-CruiseProduct/main',['./settings'],
    function (settings) {
        return {
            run: function () {
                var self = this;
                self.settings = settings;
                if ($(settings.container).length === 0) {
                    window.log('No contact us div located. Contact us not be available');
                    return;
                }
                $('.includedMenu_title').click(function (e) {
                    e.preventDefault();

                    var targetDivId = $(this).attr('href');

                    if ($(targetDivId).is(':visible')) {
                        $(targetDivId).slideUp('1000');
                        $(this).removeClass('active');
                    } else {
                        $(targetDivId).slideDown('1000');
                        $(this).addClass('active');
                    }
                });

                $('.carouselComponent.product').find('.carousel-item:first').addClass('active');

                
                
            }
        }
    }
);


